export default __webpack_public_path__ + "static/media/syndi-help.09164031.png";